<template>
    <div v-if="showAdminActions" class="block adminActionBtns">
        <p class="block_title">Admin Actions</p>
        <div v-if="!loading">
            <a href="#0" @click.prevent="sendEmailToMembers()" class="btn secondary icon-left"><ion-icon name="mail"></ion-icon> Send Email to All Members</a><br/><br/>
            <a href="#0" @click.prevent="sendEmailToJoinedMembers()" class="btn secondary icon-left"><ion-icon name="mail"></ion-icon> Send Email to Joined Members</a>
        </div>
        <div v-if="loading" class="loading small no-margin"></div>
    </div>
</template>

<script>
    const fb = require('../firebaseConfig.js')

    export default {
        data(){
            return{
                loading: false,
                showAdminActions: false
            }
        },
        props: {
            type: String,
            data: Object
        },
        mounted(){
            if(this.$store.state.currentUser !== null){
                if(this.$store.state.currentUser.uid === 'MxARUElzBNhyyJbdwYkOL55vxxJ2'){
                    this.showAdminActions = true
                }
            }
        },
        methods: {
            sendEmailToMembers(){

                let self = this

                this.loading = true

                console.log('Send email to everyone: ', self.data)

                if(!self.data.content || !self.data.subject){
                    console.log('No data content or subject available')
                    this.loading = false
                    return
                }

                self.$http.post('https://us-central1-vanmgl.cloudfunctions.net/SendPromoEmail', {
                    subject: 'OneMgl - ' + self.data.subject,
                    content: self.data.content
                }).then(response => {
                    if(response.status === 200){
                        console.log('Successfully sent promo email to everyone: ', response.body)
                    }else{
                        console.log('No email response: ', response)
                    }
                    self.loading = false
                }).catch((err) => {
                    console.log('Error post request promo email: ', err.message)
                    self.loading = false
                })
            },
            sendEmailToJoinedMembers(){

                console.log('Send email to joined members only!')
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Admin.vue